<script>
  import { onMount } from 'svelte';
  let posts = [];

  onMount(async () => {
    const prefix = 'V8o73-8jsEA';
    const apiKey = 'mw_arab2PMS1iFAvpDRt_efF-S0_kXgD2_33QT05KiE';
    const response = await window.fetch('https://api.dirv.me/posts/published/', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${prefix}.${apiKey}`
      }
    })
    const jsonData = await response.json();
    posts = jsonData.data.map(entry => entry.attributes);
  });

  const formattedDateHeading = (iso8601) => {
    const date = new Date(iso8601);
    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
    const day = date.toLocaleDateString('en-US', { day: 'numeric' });
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const year = date.toLocaleDateString('en-US', { year: 'numeric' });
    const ordinalIndicator = day === 1 ? 'st' : day === 2 ? 'nd' : 'th';
    return `<h2>${weekday}, ${day}<sup>${ordinalIndicator}</sup> ${month} ${year}.</h2>`;
  };
</script>

<style>
  .tag:not(:first-child) {
    margin-left: 2ch;
  }
</style>

<main>
  <h1>dirv.me</h1>
  {#each posts as post}
    <article>
      {@html formattedDateHeading(post.publishedAt)}
      {@html post.content}
      {#if post.tags.length > 0}
        <span id="tag-list">
          Tagged as
          {#each post.tags as tag}
            <a class="tag" href="/tags/{tag}">{tag}</a>
          {/each}
        </span>
      {/if}
    </article>
  {:else}
    <p>Loading</p>
  {/each}
</main>
